interface HeroCaseVideoCarouselDotProps {
  changeSlide: (index: number) => void
  index: number
  activeIndex: number
}

const autoplayDelay = 7000

const HeroCaseVideoCarouselDot = ({
  changeSlide,
  index,
  activeIndex,
}: HeroCaseVideoCarouselDotProps) => {
  const slideIndex = index + 1
  const text = slideIndex < 10 ? `0${slideIndex}` : slideIndex
  const isActive = activeIndex === index

  const selectSlide = () => {
    if (activeIndex !== index) {
      changeSlide(index)
    }
  }

  return (
    <li className="relative border-b-2 border-transparent transition-all duration-300">
      {isActive && (
        <span className="absolute left-0 bottom-[-2px] right-0 h-[2px] bg-white bg-opacity-30 z-10" />
      )}

      <button
        className="font-semibold text-sm sm:text-base md:text-lg"
        onClick={selectSlide}
      >
        {text}
      </button>

      {isActive && (
        <span
          className="absolute left-0 bottom-[-2px] right-0 h-[2px] bg-white z-20 scale-x-0"
          style={{
            animation: `fill ${autoplayDelay / 1000}s linear`,
          }}
        />
      )}
    </li>
  )
}

export default HeroCaseVideoCarouselDot
